function initializeSortableContainer(){
    console.log('intializeSortableContainer called');
    var $sortableContainer = $('#responseSortableContainer');
    var $sortableList = $('#responseSortableList');
    var sortableStims = [];
    var sortable = getSortableStims();
    var stimMargin = Math.max(1, Math.round(30/window.listNoStim[window.trialRow])) + "px";

    var sortablePlaceHolderCss = '<style id="ui-sortable-placeholder-style">.ui-sortable-placeholder {margin: ' + stimMargin + '}</style">';
    document.body.insertAdjacentHTML('beforeend', sortablePlaceHolderCss);

    for(var i = 1; i <= window.listNoStim[window.trialRow]; i++){
        var currentImage = images[i][window.trialRow].cloneNode(true);
        var fileSrc = currentImage.src;
        var filename = fileSrc.substring(fileSrc.lastIndexOf('/') + 1, fileSrc.lastIndexOf('.'));
        currentImage.id = filename;
        currentImage.style.margin = stimMargin;
        currentImage.style.flexShrink = "0";
        if(sortable && sortable[i] === undefined){
            currentImage.style.border = "1px";
            currentImage.style.borderStyle = "solid";
            currentImage.classList.add("ui-state-disabled");
            currentImage.setAttribute("draggable", false);
        }
        sortableStims[i] = currentImage;
    }

    if(window.columnForTrial('stimOptions', trialRow).includes('random')){
        window.randomizeStimOrder(sortableStims);
    }

    for(var i = 1; i <= window.listNoStim[window.trialRow]; i++){
        $(sortableStims[i]).appendTo($sortableList);
    }

    $($sortableList).sortable({
        items: "img:not(.ui-state-disabled)",
        //placeholder: 'ghost',
    });

    $sortableList.css({
        "display": "flex",
        "flex-direction": "row",
        "justify-content": "center",
        "align-items": "center",
        "height": "fit-content",
        "user-select": "none",
    });

    setSortableButton();

    $sortableContainer.css({
        "height": "100%",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
    });
}

function setSortableButton(){
    if(columnForTrial('button1', window.trialRow) == "na"){
        $("#submitResponseSort").css({
            "display": "block",
        });
        window.enableResponseWindowAfterMinimumDuration(disableSortable, enableSortable);
    }

    else{
        $("#button1").attr("onclick", "saveSortableResponse()");
    }
}

function disableSortable() {
    document.getElementById("submitResponseSort").setAttribute("disabled", "");
}

function enableSortable() {
    document.getElementById("submitResponseSort").removeAttribute("disabled");
}

function getSortableStims(){
    var options = columnForTrial('responseOptions', window.trialRow);
    var sortable = {};
    if(options == "na"){
        return null;
    }
    if(options.indexOf(';') > -1){
        options = options.split(';');
        for(var i = 0; i < options.length; i++){
            var currentStim = parseInt(options[i], 10);
            sortable[currentStim] = 1;
        }
    }

    else if(options.indexOf(':') > -1){
        var interval = options.split(':');
        var lowerBound = parseInt(interval[0], 10);
        var upperBound = parseInt(interval[1], 10);
        for(var i = lowerBound; i <= upperBound; i++){
            sortable[i] = 1;
        }
    }
    else{
        return null;
    }
    
    return sortable;
}

function getSortableScore(answer){
    if(answer === undefined){
        answer = [];
        $('img', '#responseSortableList').each(function(){
            answer.push($(this).attr('id'));
        });
    }
    var expected = columnForTrial('key', window.trialRow);
    var score;
    if(expected){
        var expectedArray = expected.split(';');
        if(expectedArray.length == answer.length){
            score = 0;
            for(var i = 0; i < answer.length; i++){
                var currentStim = answer[i];
                var stimuliPositionDiff = Math.abs(expectedArray.indexOf(currentStim) - i);
                score = score + stimuliPositionDiff;
            }
        }
    }
    if(score !== undefined){
        return score;
    }
}

function getSortableResponse() {
    var answer = [];
    $('img', '#responseSortableList').each(function(){
        answer.push($(this).attr('id'));
    });

    return answer.join(';');
}

function saveSortableResponse(){
    const answer = getSortableResponse();
    window.saveTrial(answer);
    window.clearSortable();
    window.clearTimeouts();
    window.endTrial();
}

function clearSortable(){
    $("#responseSortableContainer").hide();
    $("#responseSortableList").empty();
    $("#submitResponseSort").hide();
    $("#button1").attr("onclick", "clickButton1()");
    $("#ui-sortable-placeholder-style").remove();
}

function isSortTrial(trial){
    return window.columnForTrial('responseType', trial) == 'sort';
}